import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import Box, { BoxType } from 'components/Box'
import { Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import Icon from 'components/Icon'
import Section, { SectionType, Size } from 'components/Section/Section'
import * as React from 'react'
import { getCdnUrl } from '../../../../data/api/cdn'
import DisplayContent from '../../../shared/content'

interface EntriesHowItWorks {
  boxTypeColor?: BoxType
  backgroundImageLink?: string
}

const EntriesHowItWorks: React.FC<EntriesHowItWorks> = ({
  boxTypeColor = BoxType.tomatoHeaders,
  backgroundImageLink,
}) => {
  const backgroundImage = backgroundImageLink && getCdnUrl(backgroundImageLink)

  return (
    <Section type={SectionType.white} size={Size.m}>
      <Heading
        level={2}
        {...(backgroundImage && { backgroundImage })}
        centered={false}
        extraBold
      >
        <DisplayContent contentKey="home-how">How it works</DisplayContent>
      </Heading>
      <br />
      <Grid nrCols={[1, 3]} colGap={[GridGap.l]} rowGap={[GridGap.xl]}>
        <Box type={boxTypeColor}>
          <p className={'srprs-icon-head'}>
            <Icon viewBox="0 0 96 108" icon={SRPRS.searchColored} />
          </p>
          <Heading level={3}>
            <DisplayContent contentKey="home-how-step-1">
              Benefit #1
            </DisplayContent>
          </Heading>
          <div className="content">
            <p>
              <DisplayContent contentKey="home-how-step-1-story">
                story
              </DisplayContent>
            </p>
          </div>
        </Box>

        <Box type={boxTypeColor}>
          <p className={'srprs-icon-head'}>
            <Icon viewBox="0 0 62 96" icon={SRPRS.celebrateColored} />
          </p>
          <Heading level={3}>
            <DisplayContent contentKey="home-how-step-2">
              Benefit #2
            </DisplayContent>
          </Heading>
          <div className="content">
            <p>
              <DisplayContent contentKey="home-how-step-2-story">
                story
              </DisplayContent>
            </p>
          </div>
        </Box>

        <Box type={boxTypeColor}>
          <p className={'srprs-icon-head'}>
            <Icon viewBox="0 0 96 99" icon={SRPRS.starColored} />
          </p>
          <Heading level={3}>
            <DisplayContent contentKey="home-how-step-3">
              Benefit #3
            </DisplayContent>
          </Heading>
          <div className="content">
            <p>
              <DisplayContent contentKey="home-how-step-3-story">
                story
              </DisplayContent>
            </p>
          </div>
        </Box>
      </Grid>
    </Section>
  )
}

export default EntriesHowItWorks
